/** @format */
import { PlatformResellerCollectionInterface } from '../../../interfaces/collections/PlatformResellerCollectionInterface';
import { HeaderCheckBoxSelectListElement } from '../../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { useFilterParseToArray } from './useFilterParseToArray';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { platformResellerConstants } from '../../platformreseller/actions';

export const usePlatformResellerList = (currentFilters: Array<Filter> = []): PlatformResellerCollectionInterface | null => {
    const dispatch = useDispatch();
    const [platformResellerCollection, setPlatformResellerCollection] = useState<PlatformResellerCollectionInterface | null>(null);
    const filters = useRef<Array<Filter>>([]);
    const orders = useRef<Array<Order>>([]);
    filters.current = useFilterParseToArray(currentFilters, false);
    orders.current = [{ name: 'mainname', value: 'asc' }];

    useEffect(() => {
        if (platformResellerCollection === null) {
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_resellers')),
                platformResellerConstants.PLATFORM_RESELLER_LIST,
                filters.current,
                orders.current,
                (data: PlatformResellerCollectionInterface): void => {
                    setPlatformResellerCollection(data);
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [dispatch, platformResellerCollection, filters, orders]);

    return platformResellerCollection;
};

export const usePlatformResellerHeaders = (
    platformResellerCollection: PlatformResellerCollectionInterface | null
): Array<HeaderCheckBoxSelectListElement> => {
    const headers: Array<HeaderCheckBoxSelectListElement> = [];
    if (platformResellerCollection) {
        for (let i = 0; i < platformResellerCollection['hydra:member'].length; i++) {
            headers.push({ name: platformResellerCollection['hydra:member'][i].mainname, value: platformResellerCollection['hydra:member'][i].id });
        }
    }
    return headers;
};
